import { m as e } from "./map_object.js";
var f = e, i = function(a, c) {
  var t = {};
  return f(a, function(r, o) {
    c(r, o) && (t[o] = r);
  }), t;
};
export {
  i as f
};
